<template>
  <div class="is-grid">
    <f-field 
      class="is-col-12 m-bottom-20"
    >
      <f-input 
        class="m-bottom-5"
        v-model="search"
        placeholder="Rechercher un partenaire"
        long
      ></f-input>
    </f-field>

    <partner-card
      class="m-bottom-5 is-col-12"
      v-for="item in items"
      :key="item._id"
      :partner="item"
      @add="addPartner(item)"
      selectable
    ></partner-card>

    <f-button
      v-if="pagination.hasNext"
      class="m-top-5"
      @click="loadNext"
      :loading="loading"
      fill 
      long
    >
      Voir plus...
    </f-button>
  </div>

  <span></span>
</template>

<script>
  import { computed, reactive, toRefs, ref } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'
  import PartnerCard from '@components/partners/view/partner-card'
  import FreebeDesign from '@freebe/design'

  const { useList } = FreebeDesign

  export default {
    props: {
      partner_id: {
        type: [String, null],
        default: null,
      },

      partner_ids: {
        type: Array,
        default: () => [],
      },

      contact: {
        type: String,
        default: '',
      },
    },

    setup (props, context) {
      const state = reactive({
        store: '@admin/partners',
        query: {
          $sort: {
            updatedAt: -1,
            name: 1,
          }
        },
        search: '',
        fuzzy: {
          keys: ['name']
        },
        loadMore: true,
      }) 

      const list = useList(state)

      const partnerIds = ref([])

      if (props.partner_ids) {
        partnerIds.value.push(...props.partner_ids)
      }

      function addPartner (partner) {
        partnerIds.value.push(partner._id)
        const partnerName = 
          partner.contacts && partner.contacts.length ? 
          partner.contacts[0].firstname + ' ' + partner.contacts[0].lastname
          : ''

        context.emit('update:partner_ids',  partnerIds.value)
        context.emit('update:partner_id',  partner._id)
        context.emit('update:contact',  partnerName)
      }

      return {
        ...toRefs(state),
        ...list,
        addPartner,
      }
    }, 

    components: {
      PartnerCard,
    }  
  }
</script>